/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import styled from 'styled-components';
import pick from 'lodash/pick';

const FieldGroup = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;

  &:first-child {
    margin-top: 20px;
  }

  & label {
    font-size: 14px;
  }

  & label {
    font-size: 14px;
    font-weight: bold;
    color: ${props => (props.error ? props.theme.WARNING : props.theme.BLACK)};
    margin-bottom: 4px;
  }
`;

const SelectField = styled(Field)`
  width: 385px;
  height: 36px;
  border-radius: 1px;
  border: ${props => props.error ? `solid 1px ${props.theme.WARNING}` : `solid 1px ${props.theme.GREY}`};
  padding: 8px 11px;
  font-size: 14px;
  font-weight: normal;
`;

const ErrorMessage = styled.span`
  margin-left: 8px;
  font-size: 12px;
  font-weight: 400;
`;

export function FormSelectField(props) {
  const {
    inputId, label, labelId, name, isRequired, placeholder, error, options,
  } = props;

  const additionalProps = pick(props, ['checked', 'error', 'rows', 'component']);

  return (
    <FieldGroup isRequired={isRequired} error={error}>
      <label htmlFor={name} id={labelId}>
        {label}
        {isRequired && <span>*</span>}
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </label>
      <SelectField
        {...additionalProps}
        id={inputId}
        component="select"
        name={name}
        required={isRequired}
      >
        <option defaultValue>{placeholder}</option>
        {options.map(option => (
          <option value={option.id} key={option.id}>
            {option.displayName}
          </option>
        ))}
      </SelectField>
    </FieldGroup>
  );
}

FormSelectField.propTypes = {
  error: PropTypes.string,
  inputId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  labelId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  placeholder: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
};

FormSelectField.defaultProps = {
  isRequired: false,
};
